import { render, staticRenderFns } from "./bind-user-dialog.vue?vue&type=template&id=81d3b4f2&scoped=true&"
import script from "./bind-user-dialog.vue?vue&type=script&lang=js&"
export * from "./bind-user-dialog.vue?vue&type=script&lang=js&"
import style0 from "./bind-user-dialog.vue?vue&type=style&index=0&id=81d3b4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3b4f2",
  null
  
)

export default component.exports